exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/main.component.css
// module id = ../../../../../src/app/public/main.component.css
// module chunks = main